import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import AdminWorkList, { DispatchProps, OwnProps, StateProps } from './AdminWorkList';
import { StoreState } from 'src/store/reducers';
import { QueryParams } from 'src/types/grid';
import { getAdminWorks } from 'src/store/actions/adminWork-actions';
import { getAdminWorksCsv } from 'src/store/actions/adminWork-actions';
import { getProvidersSmall } from 'src/store/actions/provider-actions';
import { selectNameProviders } from '../../../../../../store/selectors/providers-selectors';

function mapStateToProps(state: StoreState, ownProps: OwnProps): StateProps {
    return {
        data: state.adminWorks.data,
        inProgress: state.adminWorks.inProgress,
        providers: selectNameProviders(state),
    };
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps): DispatchProps {
    return {
        getData: (params: QueryParams) => dispatch(getAdminWorks(params)),
        getDataCsv: (params: QueryParams) => dispatch(getAdminWorksCsv(params)),
        getProviders: (params: QueryParams) => dispatch(getProvidersSmall(params)),
    };
}

const AdminWorkListScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(AdminWorkList);

export default AdminWorkListScreen;
